import { Box, Flex } from "@chakra-ui/react";
import { DashboardHeader } from "../UnauthenticatedDashboard/DashboardHeader";
import { DashboardArea } from "./dashboardArea";
import useMediaQ from "@root/hooks/useMediaQ";

export const KpecDashboard = () => {
  const { sm } = useMediaQ();
  const isMobile = !sm;
  return (
    <Box width="100%" height="100%">
      <Flex
        direction="column"
        height="100%"
        padding={"24px 16px"}
      >
        <Box mb="12px">
          <DashboardHeader />
        </Box>

        <Box flex="1" overflowY="auto">
          <DashboardArea />
        </Box>
      </Flex>
    </Box>
  );
};
